export default "__VITE_ASSET__CyakgF6I__"